
import Gift from "../../../assets/outline/Gift.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GiftIcon({ className, dataTestid = "GiftIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Gift data-testid={dataTestid} className={classes} {...rest} />
  );
}
